import { render, staticRenderFns } from "./SetLoginPassword.vue?vue&type=template&id=79f45c14&scoped=true"
import script from "./SetLoginPassword.vue?vue&type=script&lang=js"
export * from "./SetLoginPassword.vue?vue&type=script&lang=js"
import style0 from "./SetLoginPassword.vue?vue&type=style&index=0&id=79f45c14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f45c14",
  null
  
)

export default component.exports